import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import Typo from '@/components/Typography/Typo';
import AMP_KEYS from '@/configs/amp-track-keys';
import useGlobalSearchModalAction from '@/features/GlobalSearch/hooks/useGlobalSearchModalAction';
import { cn } from '@/lib/cn';
import { track } from '@/utils/track/track';

type Props = {
  shrinked: boolean;
};

const GlobalSearchButton = (props: Props) => {
  const { openModal } = useGlobalSearchModalAction();

  const onSearchClick = () => {
    track(AMP_KEYS.GNB_SEARCH_CLICK);
    openModal();
  };

  return (
    <div className="flex items-center w-full">
      <TooltipV2
        tooltipNode="Search"
        shortcut="⌘ E"
        offset={props.shrinked ? { x: 48, y: -40 } : undefined}
      >
        <NavButtonStyle
          shrinked={props.shrinked}
          onClick={onSearchClick}
          style={{
            width: props.shrinked ? '32px' : '100%',
            height: '32px',
            justifyContent: props.shrinked ? 'center' : 'space-between',
            paddingLeft: props.shrinked ? 0 : 12,
            paddingRight: props.shrinked ? 0 : 14,
          }}
          g={6}
          a="center"
        >
          <div className="flex min-w-0 items-center gap-1.5">
            <SearchOutlined />
            <Typo
              type="label2"
              weight="m"
              className={cn(
                'origin-left transition-all duration-200 ease-out',
                props.shrinked
                  ? 'max-w-0 -translate-x-2 opacity-0'
                  : 'max-w-24 translate-x-0 opacity-100',
              )}
            >
              Search
            </Typo>
          </div>
          <div
            className={cn(
              'overflow-hidden transition-all duration-200 ease-out',
              props.shrinked
                ? 'max-w-0 translate-x-2 opacity-0'
                : 'max-w-12 translate-x-0 opacity-100',
            )}
          >
            <Typo type="label2" weight="m" className="whitespace-nowrap">
              ⌘ E
            </Typo>
          </div>
        </NavButtonStyle>
      </TooltipV2>
    </div>
  );
};

const NavButtonStyle = styled(Flex).attrs({
  a: 'center',
})<{ shrinked: boolean }>`
  font-size: 14px;
  height: 34px;
  border-radius: 8px;
  color: ${(props) => props.theme.colors.gray600};
  background-color: ${(props) =>
    props.shrinked
      ? props.theme.colors.background
      : props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.sidebar_border};
  cursor: pointer;
  overflow: hidden;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.sidebar_accent};
    border-color: ${(props) => props.theme.colors.sidebar_border};
  }
`;

export default GlobalSearchButton;
